module.exports = __webpack_public_path__ + "img/img45.a7ae1b73.svg";